<template>
    <div class="_starContainer">
        <i class="fa-star" :class="{'fas': modelValue > 0, 'far': modelValue <= 1}" @click="emitValue(1)"></i>
        <i class="fa-star" :class="{'fas': modelValue > 1, 'far': modelValue <= 2}" @click="emitValue(2)"></i>
        <i class="fa-star" :class="{'fas': modelValue > 2, 'far': modelValue <= 3}" @click="emitValue(3)"></i>
        <i class="fa-star" :class="{'fas': modelValue > 3, 'far': modelValue <= 4}" @click="emitValue(4)"></i>
        <i class="fa-star" :class="{'fas': modelValue > 4, 'far': modelValue <= 5}" @click="emitValue(5)"></i>
    </div>
</template>

<script lang="ts">
import * as OM from '@/model';
import { mixins, Options } from 'vue-class-component';
import withModel from '@/mixins/withModel';
import { Prop } from 'vue-property-decorator';

@Options({})
export default class stars extends mixins(withModel) {

    declare modelValue: number;

    emitValue(val){
        this.emitModel(val);
    }

}

</script>
<style scoped>

._starContainer i {
    color: #97bf16;
    cursor: pointer;
    margin-right: 4px;
}

</style>
